// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"117":"48359c0d","787":"5431edef"}[chunkId] + ".chunk.js";
};